import { gql } from "@apollo/client";

export const CREATE_SIGNATURE = gql`
  mutation CreateSignatureMutation($input: CreateSignatureInput!) {
    createSignature(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_SIGNATURE = gql`
  mutation UpdateSignatureMutation($id: Int!, $input: UpdateSignatureInput!) {
    updateSignature(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_SIGNATURE = gql`
  mutation RemoveSignatureMutation($id: Int!) {
    removeSignature(id: $id) {
      ok
      error
    }
  }
`;

export const SIGNATURE = gql`
  query SignatureQuery($id: Int!) {
    signature(id: $id) {
      ok
      error
      result {
        id
        signerName
        signerRole
        signedAt
        mode
        documentHashSha256
      }
    }
  }
`;

export const SIGNATURES = gql`
  query SignaturesQuery($where: SignaturesFiltersInput!) {
    signatures(where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        signerName
        mode
        signedAt
      }
    }
  }
`;
